export default {
  id: null,
  settlement_type_id: null,
  file_id: null,
  booking_id: null,
  booking_text: null,
  start_date: "",
  end_date: "",
  amount_in_currency: null,
  currency: "PLN",
  comment: "",
  invoice_date: null,
  amount: null
};
